import React, { useState, useMemo } from 'react';
import UnderwaterPlot from '../../../charts/Plotly/UnderwaterPlot';

const transformData = (data) => {
  const dates = data.map(x => x[0]);
  const prices = data.map(x => x[1]);
  return { dates, prices };
};

const Drawdowns = ({ items }) => {
  const [selectedSeries, setSelectedSeries] = useState(new Set([items[0].id]));

  const allSeries = useMemo(() => {
    return items.map(item => ({
      id: item.id,
      title: item.label,
      ...transformData(item.chart),
      colors: {
        price: `hsl(${(Math.random() * 360)}, 70%, 50%)`,
        drawdown: 'rgba(255, 49, 49, 0.7)'
      }
    }));
  }, [items]);

  const selectedSeriesData = useMemo(() => {
    return allSeries.filter(series => selectedSeries.has(series.id));
  }, [allSeries, selectedSeries]);

  return (
    <div className="w-full p-4 bg-white rounded-lg">
      <div className="flex flex-wrap gap-4 mb-6">
        {items.map(item => (
          <label
            key={item.id}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer
              transition-all duration-200 ease-in-out
              ${selectedSeries.has(item.id) 
                ? 'bg-blue-100 text-blue-800 shadow-sm' 
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}
            `}
          >
            <input
              type="checkbox"
              checked={selectedSeries.has(item.id)}
              onChange={(e) => {
                const newSelected = new Set(selectedSeries);
                if (e.target.checked) {
                  newSelected.add(item.id);
                } else if (newSelected.size > 1) {
                  newSelected.delete(item.id);
                }
                setSelectedSeries(newSelected);
              }}
              className="hidden"
            />
            {item.label}
          </label>
        ))}
      </div>

      <div className="w-full aspect-[16/9] min-h-[400px]">
        <UnderwaterPlot
          series={selectedSeriesData}
          title=""
          layout={{
            plot_bgcolor: '#ffffff',
            paper_bgcolor: '#ffffff',
            grid: {
              rows: 2,
              columns: 1,
              pattern: 'independent',
            },
            xaxis: {
              showgrid: true,
              gridcolor: '#eeefff',
              gridwidth: 1,
              rangeslider: { visible: true }
            },
            yaxis: {
              showgrid: true,
              gridcolor: '#eeefff',
              gridwidth: 1,
              domain: [0.55, 1],
              tickformat: '.0f',
              ticksuffix: '%',
              scaleanchor: 'x',
              scaleratio: 1
            },
            yaxis2: {
              showgrid: true,
              gridcolor: '#eeefff',
              gridwidth: 1,
              domain: [0, 0.45],
              tickformat: '.0f',
              ticksuffix: '%',
              scaleanchor: 'x',
              scaleratio: 1
            },
            margin: { t: 20, r: 20, b: 40, l: 40 }
          }}
        />
      </div>
    </div>
  );
};

export default Drawdowns;